import { MascotBubble } from '@tankef/ui';

import type { StepType } from '@reactour/tour';

export const TRANSFERS_TOUR_ID = 'transfers';

export const transfersSteps: StepType[] = [
  {
    selector: '[data-tour="transfer-kpi"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="happy" size="sm" direction="right" showPointer={false}>
        Aquí ves el <strong>resumen de tus transferencias</strong>: enviadas, recibidas y
        pendientes.
      </MascotBubble>
    ),
  },
  {
    selector: '[data-tour="transfer-new-btn"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="neutral" size="sm" direction="left" showPointer={false}>
        Toca <strong>Nueva transferencia</strong> para enviar dinero. Puedes buscar por email,
        teléfono o ingresar una CLABE.
      </MascotBubble>
    ),
  },
  {
    selector: '[data-tour="transfer-movements"]',
    position: 'top',
    content: (
      <MascotBubble emotion="hint" size="sm" direction="right" showPointer={false}>
        Tus <strong>movimientos recientes</strong>. Toca cualquiera para ver el detalle y descargar
        el comprobante.
      </MascotBubble>
    ),
  },
];
